import { ApiResourceMethod } from '@/api/api-requests-factory';
import {
  RealMoneyBalancePlayerListRequestModel,
} from '@/models/mga-real-money-balance/mga-real-money-balance.model';
import { FileDataResponse } from '@/models/app-internal/file-data-response.model';
import { clearObj, formatDatesInPayload } from '@marfa/bo-utils';
import { ReportListFilterFields } from '@/models/report/report-list-filter.model';

export class GetRealMoneyBalancePlayerListCsvRequest extends ApiResourceMethod<FileDataResponse> {
  public perform(params: RealMoneyBalancePlayerListRequestModel): Promise<FileDataResponse> {
    const requestData: RealMoneyBalancePlayerListRequestModel = formatDatesInPayload({
      payload: { ...params },
      isUnixToString: false,
      isIncludeTime: true,
    },
    [
      ReportListFilterFields.DATE_FROM,
      ReportListFilterFields.DATE_TO,
      ReportListFilterFields.EXCHANGE_RATE_DATE,

    ]);

    return this.performer.request(
      { params: clearObj(requestData) },
    );
  }
}
